import React from "react";
import { useTranslation } from "react-i18next";

import { Step, StepLabel, Stepper } from "@mui/material";

type Props = {
    activeStep: number;
    className?: string;
};

export const EnrollmentAndroidOsStepper = ({ activeStep, className }: Props) => {
    const { t } = useTranslation(["modals"]);

    return (
        <Stepper activeStep={activeStep} className={className}>
            <Step>
                <StepLabel>{t("modals:enrollmentDialog.imageSelectionStep.step1")}</StepLabel>
            </Step>
            <Step>
                <StepLabel>{t("modals:enrollmentDialog.imageSelectionStep.step2")}</StepLabel>
            </Step>
            <Step>
                <StepLabel>{t("modals:enrollmentDialog.imageSelectionStep.step3")}</StepLabel>
            </Step>
        </Stepper>
    );
};
